module.exports = __webpack_public_path__ + "7bfd85f52010ee32908a016907d3df20.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-13.png
// module id = 3069
// module chunks = 0